import { render, staticRenderFns } from "./statistical.vue?vue&type=template&id=1a11bfdd&scoped=true&"
import script from "./statistical.vue?vue&type=script&lang=js&"
export * from "./statistical.vue?vue&type=script&lang=js&"
import style0 from "./statistical.vue?vue&type=style&index=0&id=1a11bfdd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a11bfdd",
  null
  
)

export default component.exports